
// export const urlHttpGov = 'https://desenvolveapi.govfacilbrasil.com.br';//homologacao

export const urlHttpGov = process.env.REACT_APP_API_URL || 'https://gateway.homologacao.govfaciltecnologia.com.br';//homologacao
export const urlImgEntidades = process.env.REACT_APP_FILE_SERVER_URL_LOGOS || 'http://localhost:3000';//homologacao
export const urlImgNoticias = process.env.REACT_APP_FILE_SERVER_URL_NOTICIAS || 'http://localhost:3000';//homologacao
export const urlImgMembros = process.env.REACT_APP_FILE_SERVER_URL_MEMBROS || 'http://localhost:3000';//homologacao
// export const urlHttpGov = 'https://govfacil-gestor-backend-homologacao.gestor.govfacil.app';//homologacao

// export const urlHttpGov = 'https://desenvolveapi.govfacil.app';//producao

export const urlUsuarioSession = urlHttpGov + `${process.env.REACT_APP_BACKEND === 'local' ? '' : '/gestor'}/auth`
export const urlUsuariosSessionRefreshToken = urlHttpGov + `${process.env.REACT_APP_BACKEND === 'local' ? '' : '/gestor'}/auth/refresh_token`
